import { useLanguage } from '@/context/LanguageContext'
import { useHead } from '@unhead/react'
import {ArrowLeft, BookOpen, ShoppingCart} from 'lucide-react'
import { Link } from 'react-router-dom'
import { EBOOKS } from '@/config/links'

function Ebook() {
  const { t, lang } = useLanguage()

  useHead({
    htmlAttrs: { lang },
    title: t.ebook.metaTitle,
    meta: [
      { name: 'description', content: t.ebook.metaDescription },
      { property: 'og:title', content: t.ebook.metaTitle },
      { property: 'og:description', content: t.ebook.metaDescription },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
    ],
  })

  return (
    <div className="min-h-screen bg-[#2b1c12]">
      <header className="max-w-md mx-auto px-4 pt-6 pb-2">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-amber-300 text-sm hover:text-amber-200 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          {t.ebook.back}
        </Link>
      </header>

      <main className="max-w-md mx-auto px-4 pt-6 pb-14">
        <div className="flex items-center gap-2 mb-3">
          <BookOpen className="w-5 h-5 text-amber-400" />
          <h1 className="text-2xl font-bold text-amber-50">{t.ebook.title}</h1>
        </div>
        <p className="text-amber-100/75 text-sm leading-relaxed mb-8">
          {t.ebook.intro}
        </p>

        <div className="flex flex-col gap-2.5">
          {EBOOKS.map((item, index) => (
            <div
              key={item.id}
              className="flex rounded-xl overflow-hidden border border-amber-800/30 bg-[#3d2b1f] animate-fade-in-up"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-20 h-24 object-cover shrink-0"
              />
              <div className="p-2.5 flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-0.5">
                  <h2 className="text-amber-50 font-semibold text-xs truncate">
                    {item.title}
                  </h2>
                  <span className="shrink-0 text-[9px] font-medium uppercase tracking-wide text-amber-300 bg-amber-900/40 border border-amber-700/40 rounded-full px-1.5 py-0.5">
                    {item.language}
                  </span>
                </div>
                <p className="text-amber-100/65 text-[11px] leading-snug mb-2 line-clamp-2">
                  {item.caption}
                </p>
                <a
                  href={item.buyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-1.5 w-full rounded-lg bg-amber-500 hover:bg-amber-400 text-[#2b1c12] font-semibold text-xs py-1.5 transition-colors"
                >
                  <ShoppingCart className="w-3.5 h-3.5" />
                  {item.language === 'EN' ? 'Buy this plan' : t.ebook.buyCta}
                </a>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-amber-100/50 text-xs mt-8">
          {t.ebook.comingSoon}
        </p>
      </main>
    </div>
  )
}

export default Ebook
